import React from 'react';
import {
  DetailsDisclaimerText,
  DetailsModalHeadingText,
  DetailsModalInfoContainer,
  DetailsModalLeftContainer,
  DetailsModalRightContainer,
  DetailsModalTextBold,
  DetailsModalTextNormal,
  DetailsModalTextSmall,
  DetailsModalWarningText,
  DetailsSubContainer,
  LineBreak,
  LineBreakLight,
  TimeLineContainer
} from '../../forex-pages/send-money-calculator/style';
import {
  DOWN_CHEVERON_NEW_ICON,
  ROUND_DASH_ICON,
  ROUND_EQUALS_ICON,
  ROUND_CROSS_ICON
} from '@Images';
import { DETAILS_SCREEN } from '../constants';
import { IPaymentDetailsProps } from '../interface';
import { formatCurrencyToTwoDecimalPlaces, formatCurrencyAmount } from '@Utils/library';
const PaymentDetailsContainer: React.FC<IPaymentDetailsProps> = ({
  transactionConfig,
  handleShowFees,
  showFees,
  showTax,
  handleBreakUpClick,
  isPaymentScreen = false
}) => {
  const {
    sourceAmount,
    destinationAmount,
    sourceCurrency,
    destinationCurrency,
    transactionFeeAmount,
    computedData,
    instarem_fx_rate,
    netSourceAmount,
    couponAmount
  } = transactionConfig;

  const { tax_amount_1, tax_amount_2, tax_amount_3, net_tax_amount } = computedData;
  const {
    transactionDetails,
    send,
    totalFees,
    transactionFees,
    bankFees,
    bankDepositFees,
    amountToConvert,
    exchangeRate,
    recipientGets,
    amountPayable,
    tax,
    tcs,
    cgstNetFee,
    SgstNetFee,
    CgstTransactionFee,
    SgstTransactinFee,
    youPayExactly,
    SgstCalculationDisclaimer,
    gstCalculatorPaymentReview,
    transferDetails,
    appliedDiscount
  } = DETAILS_SCREEN;

  return (
    <DetailsSubContainer>
      <DetailsModalHeadingText>
        {isPaymentScreen ? transferDetails : transactionDetails}
      </DetailsModalHeadingText>

      <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 12, 0]}>
        <DetailsModalLeftContainer>
          <DetailsModalTextBold>{send}</DetailsModalTextBold>
        </DetailsModalLeftContainer>
        <DetailsModalRightContainer>
          <DetailsModalTextBold>
            {`${formatCurrencyAmount(
              formatCurrencyToTwoDecimalPlaces(sourceAmount)
            )} ${sourceCurrency}`}
          </DetailsModalTextBold>
        </DetailsModalRightContainer>
      </DetailsModalInfoContainer>
      <LineBreak />

      <TimeLineContainer>
        <div className="timelineContainer">
          <div className="timelineEvent">
            <div className="timelineMarker">
              <span className="timelineIcon timelineStartImage">
                <img src={ROUND_DASH_ICON} alt="logo" />
              </span>
            </div>
            <div className="timelineLineStart"></div>
            <div className="timelineContentStart">
              <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 9, 0]}>
                <DetailsModalLeftContainer>
                  <p>
                    <span className="inlineContent">
                      <DetailsModalTextNormal>{totalFees}</DetailsModalTextNormal>
                    </span>
                    <span className="inlineContent">
                      {showFees ? (
                        <img
                          className="upArrow"
                          onClick={handleShowFees}
                          src={DOWN_CHEVERON_NEW_ICON}
                          alt="arrow"
                        />
                      ) : (
                        <img
                          className="downArrow"
                          onClick={handleShowFees}
                          src={DOWN_CHEVERON_NEW_ICON}
                          alt="arrow"
                        />
                      )}
                    </span>
                  </p>
                </DetailsModalLeftContainer>
                <DetailsModalRightContainer>
                  <DetailsModalWarningText>
                    {`${formatCurrencyAmount(
                      formatCurrencyToTwoDecimalPlaces(transactionFeeAmount)
                    )} ${sourceCurrency}`}
                  </DetailsModalWarningText>
                </DetailsModalRightContainer>
              </DetailsModalInfoContainer>

              {showFees && (
                <div>
                  <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
                    <DetailsModalLeftContainer>
                      <DetailsModalTextNormal>{transactionFees}</DetailsModalTextNormal>
                    </DetailsModalLeftContainer>
                    <DetailsModalRightContainer>
                      <DetailsModalTextNormal>{`${formatCurrencyAmount(
                        formatCurrencyToTwoDecimalPlaces(transactionFeeAmount)
                      )} ${sourceCurrency}`}</DetailsModalTextNormal>
                    </DetailsModalRightContainer>
                  </DetailsModalInfoContainer>

                  <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
                    <DetailsModalLeftContainer>
                      <DetailsModalTextNormal>{bankFees}</DetailsModalTextNormal>
                    </DetailsModalLeftContainer>
                    <DetailsModalRightContainer>
                      <DetailsModalTextNormal>{`${formatCurrencyAmount(
                        formatCurrencyToTwoDecimalPlaces(computedData?.payment_method_fee_amount)
                      )} ${sourceCurrency}`}</DetailsModalTextNormal>
                    </DetailsModalRightContainer>
                  </DetailsModalInfoContainer>

                  <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
                    <DetailsModalLeftContainer>
                      <DetailsModalTextNormal>{bankDepositFees}</DetailsModalTextNormal>
                    </DetailsModalLeftContainer>
                    <DetailsModalRightContainer>
                      <DetailsModalTextNormal>{`${formatCurrencyAmount(
                        formatCurrencyToTwoDecimalPlaces(computedData?.payment_method_fee_amount)
                      )} ${sourceCurrency}`}</DetailsModalTextNormal>
                    </DetailsModalRightContainer>
                  </DetailsModalInfoContainer>
                </div>
              )}
            </div>
          </div>

          <div className="timelineEvent">
            <div className="timelineMarker">
              <span className="timelineIcon">
                <img src={ROUND_EQUALS_ICON} alt="logo" />
              </span>
            </div>
            <div className="timelineLine"></div>
            <div className="timelineContentStart timeLineBorder">
              <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 9, 0]}>
                <DetailsModalLeftContainer>
                  <DetailsModalTextNormal>{amountToConvert}</DetailsModalTextNormal>
                </DetailsModalLeftContainer>
                <DetailsModalRightContainer>
                  <DetailsModalTextNormal>
                    {`${formatCurrencyAmount(
                      formatCurrencyToTwoDecimalPlaces(computedData?.net_of_fee_amount)
                    )} ${sourceCurrency}`}
                  </DetailsModalTextNormal>
                </DetailsModalRightContainer>
              </DetailsModalInfoContainer>
            </div>
          </div>

          <div className="timelineEvent">
            <div className="timelineMarker">
              <span className="timelineIcon">
                <img src={ROUND_CROSS_ICON} alt="logo" />
              </span>
            </div>
            <div className="timelineLine maxHeight"></div>
            <div className="timelineContentStart">
              <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
                <DetailsModalLeftContainer>
                  <DetailsModalTextNormal>{exchangeRate}</DetailsModalTextNormal>
                </DetailsModalLeftContainer>
                <DetailsModalRightContainer>
                  <DetailsModalTextNormal>
                    {` 1 ${sourceCurrency} = ${instarem_fx_rate} ${destinationCurrency}`}
                  </DetailsModalTextNormal>
                </DetailsModalRightContainer>
              </DetailsModalInfoContainer>
            </div>
          </div>
        </div>
      </TimeLineContainer>

      <LineBreakLight />

      <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[8, 0, 8, 0]}>
        <DetailsModalLeftContainer>
          <DetailsModalTextBold>{recipientGets}</DetailsModalTextBold>
        </DetailsModalLeftContainer>
        <DetailsModalRightContainer>
          <DetailsModalTextBold>
            {`${formatCurrencyAmount(
              formatCurrencyToTwoDecimalPlaces(destinationAmount)
            )} ${destinationCurrency}`}
          </DetailsModalTextBold>
        </DetailsModalRightContainer>
      </DetailsModalInfoContainer>

      <LineBreak />

      <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 8, 0]}>
        <DetailsModalLeftContainer>
          <DetailsModalTextNormal>{amountPayable}</DetailsModalTextNormal>
        </DetailsModalLeftContainer>
        <DetailsModalRightContainer>
          <DetailsModalTextNormal>{`${formatCurrencyAmount(
            formatCurrencyToTwoDecimalPlaces(sourceAmount)
          )} ${sourceCurrency}`}</DetailsModalTextNormal>
        </DetailsModalRightContainer>
      </DetailsModalInfoContainer>

      <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
        <DetailsModalLeftContainer>
          <p>
            <span className="inlineContent">
              <DetailsModalTextNormal>{tax}</DetailsModalTextNormal>
            </span>
            <span className="inlineContent">
              {showTax ? (
                <img
                  className="upArrow"
                  onClick={handleBreakUpClick}
                  src={DOWN_CHEVERON_NEW_ICON}
                  alt="arrow"
                />
              ) : (
                <img
                  className="downArrow"
                  onClick={handleBreakUpClick}
                  src={DOWN_CHEVERON_NEW_ICON}
                  alt="arrow"
                />
              )}
            </span>
          </p>
        </DetailsModalLeftContainer>
        <DetailsModalRightContainer>
          <DetailsModalTextNormal>{`${formatCurrencyAmount(
            formatCurrencyToTwoDecimalPlaces(net_tax_amount)
          )} ${sourceCurrency}`}</DetailsModalTextNormal>
        </DetailsModalRightContainer>
      </DetailsModalInfoContainer>

      {showTax && (
        <div className="taxContainer">
          <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
            <DetailsModalLeftContainer>
              <DetailsModalTextSmall>{cgstNetFee}</DetailsModalTextSmall>
            </DetailsModalLeftContainer>
            <DetailsModalRightContainer>
              <DetailsModalTextSmall>
                {` ${formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(tax_amount_1 / 2)
                )} ${sourceCurrency}`}
              </DetailsModalTextSmall>
            </DetailsModalRightContainer>
          </DetailsModalInfoContainer>

          <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
            <DetailsModalLeftContainer>
              <DetailsModalTextSmall>{SgstNetFee}</DetailsModalTextSmall>
            </DetailsModalLeftContainer>
            <DetailsModalRightContainer>
              <DetailsModalTextSmall>
                {` ${formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(tax_amount_1 / 2)
                )} ${sourceCurrency}`}
              </DetailsModalTextSmall>
            </DetailsModalRightContainer>
          </DetailsModalInfoContainer>

          <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
            <DetailsModalLeftContainer>
              <DetailsModalTextSmall>{CgstTransactionFee}</DetailsModalTextSmall>
            </DetailsModalLeftContainer>
            <DetailsModalRightContainer>
              <DetailsModalTextSmall>
                {` ${formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(tax_amount_2 / 2)
                )} ${sourceCurrency}`}
              </DetailsModalTextSmall>
            </DetailsModalRightContainer>
          </DetailsModalInfoContainer>

          <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
            <DetailsModalLeftContainer>
              <DetailsModalTextSmall>{SgstTransactinFee}</DetailsModalTextSmall>
            </DetailsModalLeftContainer>
            <DetailsModalRightContainer>
              <DetailsModalTextSmall>
                {` ${formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(tax_amount_2 / 2)
                )} ${sourceCurrency}`}
              </DetailsModalTextSmall>
            </DetailsModalRightContainer>
          </DetailsModalInfoContainer>

          <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[0, 0, 0, 0]}>
            <DetailsModalLeftContainer>
              <DetailsModalTextSmall>{tcs}</DetailsModalTextSmall>
            </DetailsModalLeftContainer>
            <DetailsModalRightContainer>
              <DetailsModalWarningText>
                {` ${formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(tax_amount_3)
                )} ${sourceCurrency}`}
              </DetailsModalWarningText>
            </DetailsModalRightContainer>
          </DetailsModalInfoContainer>
        </div>
      )}

      {couponAmount && (
        <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[8, 0, 24, 0]}>
          <DetailsModalLeftContainer>
            <DetailsModalTextSmall>{appliedDiscount}</DetailsModalTextSmall>
          </DetailsModalLeftContainer>
          <DetailsModalRightContainer>
            <DetailsModalTextSmall>{`${formatCurrencyAmount(
              formatCurrencyToTwoDecimalPlaces(couponAmount)
            )} ${sourceCurrency}`}</DetailsModalTextSmall>
          </DetailsModalRightContainer>
        </DetailsModalInfoContainer>
      )}

      <DetailsModalInfoContainer padding={[0, 0, 0, 0]} margin={[8, 0, 24, 0]}>
        <DetailsModalLeftContainer>
          <DetailsModalTextBold>{youPayExactly}</DetailsModalTextBold>
        </DetailsModalLeftContainer>
        <DetailsModalRightContainer>
          <DetailsModalTextBold>{`${formatCurrencyAmount(
            formatCurrencyToTwoDecimalPlaces(netSourceAmount)
          )} ${sourceCurrency}`}</DetailsModalTextBold>
        </DetailsModalRightContainer>
      </DetailsModalInfoContainer>

      <DetailsDisclaimerText>
        {isPaymentScreen ? gstCalculatorPaymentReview : SgstCalculationDisclaimer}
      </DetailsDisclaimerText>
    </DetailsSubContainer>
  );
};

export default PaymentDetailsContainer;
